export const OFFER_TESTING_MODE = false;

export const OFFER_SUBMISSION_STATUS = {
  SUBMITTED: 2,
};

export const OFFER_OFFERING_STATUS = {
  CLOSING: 'Closing',
};

export const isOfferSubmissionSubmitted = submissionStatus =>
  Number(submissionStatus) === OFFER_SUBMISSION_STATUS.SUBMITTED;

export const isOfferOfferingClosing = statusOfferingWording =>
  String(statusOfferingWording ?? '').trim() === OFFER_OFFERING_STATUS.CLOSING;

export const isOfferSubmittedEditableForTesting = ({
  testing = OFFER_TESTING_MODE,
  submissionStatus,
} = {}) => testing === true && isOfferSubmissionSubmitted(submissionStatus);

export const isOfferClosingEditableForTesting = ({
  testing = OFFER_TESTING_MODE,
  statusOfferingWording,
} = {}) => testing === true && isOfferOfferingClosing(statusOfferingWording);

export const isOfferDetailReadOnly = ({
  statusOfferingWordingFlag,
  statusOfferingWording,
  submissionStatus,
  testing = OFFER_TESTING_MODE,
} = {}) => {
  const isSubmittedLocked =
    isOfferSubmissionSubmitted(submissionStatus) &&
    !isOfferSubmittedEditableForTesting({ testing, submissionStatus });

  const isOfferingLocked =
    statusOfferingWordingFlag === true &&
    !isOfferClosingEditableForTesting({ testing, statusOfferingWording });

  return isOfferingLocked || isSubmittedLocked;
};

export const canRespondOnOfferDetail = (formMain = {}) =>
  !isOfferDetailReadOnly({
    statusOfferingWordingFlag: formMain.statusOfferingWordingFlag,
    statusOfferingWording: formMain.statusOfferingWording,
    submissionStatus: formMain.submissionStatus,
  });

export const isOfferDeliveryEditable = (formMain = {}) =>
  canRespondOnOfferDetail(formMain);

export const isOfferInvitationValidationBlocked = ({
  proposalDate,
  submissionStatus,
  statusOfferingWording,
  now = new Date(),
  testing = OFFER_TESTING_MODE,
} = {}) => {
  const isExpired = proposalDate ? proposalDate < now : false;
  // Closing juga terjadi saat evaluasi ditutup, walau Validity Period belum lewat.
  const isClosing = isExpired || isOfferOfferingClosing(statusOfferingWording);
  const isExpiredLocked =
    isClosing &&
    !isOfferClosingEditableForTesting({ testing, statusOfferingWording });
  const isSubmittedLocked =
    isOfferSubmissionSubmitted(submissionStatus) &&
    !isOfferSubmittedEditableForTesting({ testing, submissionStatus });

  return isExpiredLocked || isSubmittedLocked;
};
